import { InsightsGeneratorHelper } from '../insights-generator/insights-generator.helper';

export class MarkdownPayloadHelper {
  static storeTableAsMarkdown(component: any): void {
    if (component.tableOutputComponent) {
      const markdown = component.tableOutputComponent.extractMarkdownTable();
      if (markdown) {
        console.log('[MarkdownPayloadHelper] Extracted Table Markdown:', { length: markdown.length });
        component.insights_payload = markdown;
      }
    } else {
      console.warn('[Crosstab Markdown] tableOutputComponent is not initialized or rendered yet.');
    }
  }

  static buildSnapshotMarkdown(component: any): void {
    try {
      console.log('[MarkdownPayloadHelper] Building Snapshot Markdown...');
      const md = InsightsGeneratorHelper.buildSnapshotMarkdownFromWidget(
        component.filteredWidgetData
      );
      console.log('[MarkdownPayloadHelper] Snapshot Markdown Generated:', { length: md?.length });
      component.snapshotinsights_payload = md;
    } catch (err) {
      console.error('[Snapshot Markdown] Error:', err);
    }
  }

  static async buildMarkdownPayload(component: any): Promise<any> {
    try {
      console.log('[MarkdownPayloadHelper] Acquiring Bearer Token and Building Payload...');
      const token = await component.getBearerToken();
      const isSnapshot = component.mcode === 1;

      const basePayload: any = {
        client_name: component.selected_client || component.landingdata?.client_code || '',
        study: component.selected_study || component.landingdata?.study || '',
        session_id: component.guidChatId,
        bearer_token: token,
        markdown: isSnapshot ? component.snapshotinsights_payload : component.insights_payload,
        mcode: component.mcode,
        query: component.inputValue,
        debug_mode: false
      };

      if (isSnapshot) {
        basePayload.selected_doc_id = component.chatPayload?.selected_doc_id || component.promptData?.selected_doc_id || '';
        
        if (component.filteredWidgetData) {
          console.log('[MarkdownPayloadHelper] Enriching Snapshot Payload with Widget Details...');
          basePayload['widget_details'] = {
            widget_name: component.filteredWidgetData.widget_name || '',
            widget_id: component.filteredWidgetID || '',
            widgetchart_name: component.filteredWidgetData.widgetchart_name || '',
            Snapshot_Name: component.Snapshotdataforexport?.snapshotName || '',
            Snapshot_Type: component._configService.selectedSnapshotType || '',
            Section: component.selectedSection
          };
        }
      }

      console.log('[MarkdownPayloadHelper] Final Payload Construction COMPLETE:');
      console.log(' - MCODE:', basePayload.mcode);
      console.log(' - Query:', basePayload.query);
      console.log(' - Token Preview:', basePayload.bearer_token?.substring(0, 20) + '...');
      console.log(' - Markdown Segment (first 200 chars):', basePayload.markdown?.substring(0, 200));
      
      return basePayload;

    } catch (err) {
      console.error('[Markdown Payload] Error building payload:', err);
      return null;
    }
  }
}
